import React from 'react';
import type { SortEnd } from 'react-sortable-hoc';

import { usePageStore } from '@client/store/pageStore/context/pageContext';
import { RecipeSection } from '@ledium/types';
import { RecipeSections } from '@ledium/ui-common';
import { Grid, Typography } from '@mui/material';
import arrayMove from 'array-move';

interface RecipeEditorSectionsProps {
    setSelectedSection: (section: RecipeSection | null) => void;
}

const RecipeEditorSections = ({ setSelectedSection }: RecipeEditorSectionsProps) => {
    const {
        pageState: { formData },
        pageActions
    } = usePageStore();

    function onSort({ oldIndex, newIndex }: SortEnd) {
        pageActions.formData.updateFormItem({ sectionList: arrayMove(formData.sectionList as RecipeSection[], oldIndex, newIndex) });
    }

    function onSelectSection(section: RecipeSection) {
        setSelectedSection(section);
    }

    return (
        <>
            {(formData.sectionList as RecipeSection[]).length ? (
                <Grid item xs={12}>
                    <RecipeSections
                        sectionList={formData.sectionList as RecipeSection[]}
                        onSort={onSort}
                        onSectionClick={onSelectSection}
                        readOnly={!!formData.readOnly}
                    />
                </Grid>
            ) : (
                !formData.readOnly && (
                    <Grid item xs={12} style={{ textAlign: 'center' }}>
                        <Typography variant="subtitle2">This Project is empty. You have to add at least 1 section.</Typography>
                    </Grid>
                )
            )}
        </>
    );
};

export default RecipeEditorSections;
